export default __webpack_public_path__ + "bc91dc85eb0af690f558fa551316dc32.svg";